import 'whatwg-fetch';
import { Promise } from 'es6-promise';

// const dbIpKey = '220ba58589836fdf0ba6ca2351d7d6ea6d1875df';
// const dbIpRoute = 'https://api.db-ip.com/v2/220ba58589836fdf0ba6ca2351d7d6ea6d1875df';

const setLocationProperties = (data) => {
  const location = {
    ip: data.ipAddress,
    lat: data.latitude,
    lon: data.longitude,
    city: data.city,
    state: data.stateProv,
    zipcode: data.zipCode,
    timezone: data.timeZone
  };
  return location;
};

const LocateUser = (user) => {
  return new Promise((resolve, reject) => {
    fetch('https://api.ipify.org?format=json'
      ).then( ipResponse =>
        ipResponse.json().then( ip => ip.ip )
      ).then(
        ip => fetch('https://us-central1-eaten-f92d5.cloudfunctions.net/blessed-ip-proxy?ip=' + ip
          ).then( response =>
            response.json().then(
              resp => setLocationProperties(resp)
            )
          ).then(
            res => resolve( Object.assign(user, res) )
          )
      ).catch( err => console.log(err) );
    }
  );
};

export default LocateUser;



// WEBPACK FOOTER //
// ./client/helpers/LocateUser.js